import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-account-book',
  templateUrl: './account-book.component.html',
  styleUrls: ['./account-book.component.scss'],
  standalone: false
})
export class AccountBookComponent implements OnInit {
  public token: any;
  public quickbookStatus: any;
  public xeroStatus: any;
  public statusMessage: any = 'Error in Connection';
  freshbooksStatus: any;

  constructor(private sharedService: SharedService, private apiService: ApiService, private router: Router, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.quickbookStatus = params.quickbooks;
      this.xeroStatus = params.xero;
      this.freshbooksStatus = params.freshbooks;
    });
  }

  ngOnInit() {
    this.token = this.sharedService.clientToken;
    if (this.quickbookStatus == 1) {
      this.router.navigate(['/client-account-setup'], {queryParams: {quickbooks: 1}});
      this.statusMessage = 'Connected to QuickBooks Successfully';
    } else if (this.xeroStatus == 1) {
      this.router.navigate(['/client-account-setup'], {queryParams: {xero: 1}});
      this.statusMessage = 'Connected to Xero Successfully';
    } else if (this.freshbooksStatus == 1) {
      this.router.navigate(['/client-account-setup'], {queryParams: {freshbooks: 1}});
      this.statusMessage = 'Connected to Freshbooks Successfully';
    } else if (this.quickbookStatus == 0) {
      this.router.navigate(['/client-account-setup'], {queryParams: {quickbooks: 0}});
      this.statusMessage = 'Error in connecting to QuickBooks';
    } else if (this.xeroStatus == 0) {
      this.router.navigate(['/client-account-setup'], {queryParams: {xero: 0}});
      this.statusMessage = 'Error in connecting to Xero';
    } else if (this.freshbooksStatus == 0) {
      this.router.navigate(['/client-account-setup'], {queryParams: {freshbooks: 0}});
      this.statusMessage = 'Error in connecting to Freshbooks';
    }
    // setTimeout(() => { this.router.navigate(['/']); }, 2000);
  }

  openTermsPrivacyDialog(val) {
    this.sharedService.termsPrivacyShow.next(val);
  }
}
